import script from "./PermissionView.vue?vue&type=script&setup=true&lang=js"
export * from "./PermissionView.vue?vue&type=script&setup=true&lang=js"

import "./PermissionView.vue?vue&type=style&index=0&id=ee4f1244&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee4f1244"]])

export default __exports__